// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventPresentmentUriSchemeOpenID4VP
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.eventlogger.EventPresentmentData
import org.multipaz.eventlogger.toDataItem
import org.multipaz.eventlogger.fromDataItem

fun EventPresentmentUriSchemeOpenID4VP.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "KboOskDfPjn6v9TMh5zWXFhZsGKyby2PWjz2jORDpVY")
val EventPresentmentUriSchemeOpenID4VP_cborSchemaId = ByteString(41, -70, 14, -78, 64, -33, 62, 57, -6, -65, -44, -52, -121, -100, -42, 92, 88, 89, -80, 98, -78, 111, 45, -113, 90, 60, -10, -116, -28, 67, -91, 86)

fun EventPresentmentUriSchemeOpenID4VP.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "PresentmentUriSchemeOpenID4VP")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("presentmentData", this.presentmentData.toDataItem())
    builder.put("uri", Tstr(this.uri))
    val appId = this.appId
    if (appId != null) {
        builder.put("appId", Tstr(appId))
    }
    val origin = this.origin
    if (origin != null) {
        builder.put("origin", Tstr(origin))
    }
    builder.put("requestJwt", Tstr(this.requestJwt))
    builder.put("vpToken", Tstr(this.vpToken))
    val redirectUri = this.redirectUri
    if (redirectUri != null) {
        builder.put("redirectUri", Tstr(redirectUri))
    }
    val state = this.state
    if (state != null) {
        builder.put("state", Tstr(state))
    }
    return builder.end().build()
}

fun EventPresentmentUriSchemeOpenID4VP_fromDataItem(dataItem: DataItem): EventPresentmentUriSchemeOpenID4VP {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val presentmentData = EventPresentmentData.fromDataItem(dataItem["presentmentData"])
    val uri = dataItem["uri"].asTstr
    val appId0 = if (dataItem.hasKey("appId")) {
        dataItem["appId"].asTstr
    } else {
        null
    }
    val origin0 = if (dataItem.hasKey("origin")) {
        dataItem["origin"].asTstr
    } else {
        null
    }
    val requestJwt = dataItem["requestJwt"].asTstr
    val vpToken = dataItem["vpToken"].asTstr
    val redirectUri0 = if (dataItem.hasKey("redirectUri")) {
        dataItem["redirectUri"].asTstr
    } else {
        null
    }
    val state0 = if (dataItem.hasKey("state")) {
        dataItem["state"].asTstr
    } else {
        null
    }
    return EventPresentmentUriSchemeOpenID4VP(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        presentmentData = presentmentData,
        uri = uri,
        appId = appId0,
        origin = origin0,
        requestJwt = requestJwt,
        vpToken = vpToken,
        redirectUri = redirectUri0,
        state = state0,
    )
}
